import { ISelctedSeat } from "@/redux/rent/types";
import { validateAndPrepareBasketItems, BasketItem } from "./validateAndPrepareBasketItems";
import { generateGuid } from "@/utils/generateGuid";

export interface CreateCancelRentRequest {
  newReserve: Array<{
    courtId: string;
    startTime: string; // ISO string
    finishTime: string; // ISO string
  }>;
  cancelReserve: Array<{
    courtId: string;
    startTime: string; // ISO string
    finishTime: string; // ISO string
  }>;
  guid: string;
  changeDate: string; // ISO string
  partnerId: string;
}

export function prepareCreateCancelRentData(
  newBasket: { [key: string]: ISelctedSeat },
  cancelBasket: { [key: string]: ISelctedSeat } = {},
  partnerId: string,
  phone?: string
): CreateCancelRentRequest {
  const newReserve = validateAndPrepareBasketItems(newBasket);
  
  const cancelReserve = validateAndPrepareBasketItems(cancelBasket);

  const guidData = {
    phone: phone || '',
    newReserve,
    cancelReserve,
  };
  const guid = generateGuid(guidData);

  const changeDate = new Date().toISOString();

  return {
    newReserve,
    cancelReserve,
    guid,
    changeDate,
    partnerId,
  };
}
